/**
 * 遅い書き方と速い書き方の答え（標準出力）が一致するか（labs.md「同じ N seed なら … 答えが一致することも確かめます」）。
 * 両方で正常に終わった N だけを比べる。メーターの判断には使わない（stdout は採点しない。complexity-meter.md §2）。
 */
import { groupDigits, type MeterPoint } from '../../lib/complexity';

export interface Agreement {
  ok: boolean;
  compared: number[];
  differs: number[];
  text: string;
}

function finished(p: MeterPoint): boolean {
  return !p.timedOut && p.exitCode === 0;
}

export function outputAgreement(
  a: readonly MeterPoint[],
  aOut: readonly string[],
  b: readonly MeterPoint[],
  bOut: readonly string[],
): Agreement | null {
  const compared: number[] = [];
  const differs: number[] = [];
  a.forEach((pa, i) => {
    const j = b.findIndex((pb) => pb.n === pa.n);
    const pb = b[j];
    if (!pb || !finished(pa) || !finished(pb)) return;
    compared.push(pa.n);
    if ((aOut[i] ?? '').trimEnd() !== (bOut[j] ?? '').trimEnd()) differs.push(pa.n);
  });
  if (compared.length === 0) return null;
  const list = (ns: number[]) => ns.map(groupDigits).join(', ');
  return differs.length === 0
    ? {
        ok: true,
        compared,
        differs,
        text: `両方が終わった N = ${list(compared)} で、2 つの版の出力は一致しました。`,
      }
    : {
        ok: false,
        compared,
        differs,
        text: `N = ${list(differs)} で、2 つの版の出力が異なります。`,
      };
}
